export default __webpack_public_path__ + "static/media/Airlink-airline-logo(4Z).df6725f1.png";